(function () {
  class Clipboard {
    constructor() {
      $(".js-clipboard").on("click", function () {
        const text = this.dataset.text;
        const success = this.dataset.success;

        if (!text) { return };

        navigator.clipboard.writeText(text)
          .then(() => {
            if (!success) { return };

            const messageElement = document.createElement("span");
            const wrapper = this.parentNode;
            messageElement.innerText = success

            wrapper.innerHTML = "";
            wrapper.appendChild(this);
            wrapper.insertBefore(messageElement, this.nextSibling);
          })
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const clipboard = new Clipboard();
  }, false);
})();

